import "./Loader.scss";
export const Loader = (props: { size: TLoadSize }) => {
	return <span className={`base_loader ${props.size.toLowerCase()}`}></span>;
};

export type TLoadSize = "L_SMALL" | "L_LARGE" | "L_MEDIUM";
